import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';

export default {
  mixins: [featureFlagMixin],
  computed: {
    searchPageLegacyUI() {
      return !this.isFeatureEnabled('search_page_2025');
    },
    searchPage2025UI() {
      return this.isFeatureEnabled('search_page_2025');
    },
    searchContentClass() {
      return this.isFeatureEnabled('search_page_2025') ? 'search-page-2025' : '';
    },
    searchBarClass() {
      return this.isFeatureEnabled('search_page_2025') ? 'col-xl-9' : 'col-xl-7 col-xxl-6';
    },
    isSearchRepo() {
      return process.env.VUE_APP_PROJECT_NAME && process.env.VUE_APP_PROJECT_NAME === 'frontend-search';
    },
  },
};
